export default __webpack_public_path__ + "static/media/1-1.76d4da9f.webp";